export default __webpack_public_path__ + "static/media/success.fc4f61e2.png";